export const CHART_TYPES = Object.freeze({
  LINE: 'line',
  BAR: 'bar'
});
